const BASE_URL = process.env.REACT_APP_BASE_URL;

const getAuthHeaders = () => {
  const token = localStorage.getItem("token");
  return {
    "Content-Type": "application/x-www-form-urlencoded",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
};

const postFormData = async (url, data) => {
  const params = new URLSearchParams();

  Object.keys(data || {}).forEach((key) => {
    if (data[key] !== undefined && data[key] !== null) {
      params.append(key, data[key]);
    }
  });

  const response = await fetch(`${BASE_URL}${url}`, {
    method: "POST",
    headers: getAuthHeaders(),
    body: params.toString(),
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData?.message || "Request failed");
  }

  return response.json();
};

// 🔹 Church Prayers
export const readChurchPrayersAPI = (data) =>
  postFormData("churches/followers/prayers", data);

// 🔹 Channel Prayers
export const readChannelPrayersAPI = (data) =>
  postFormData("channels/followers/prayers", data);

// 🔹 Ministry Prayers
export const readMinistryPrayersAPI = (data) =>
  postFormData("ministries/followers/prayers", data);
